module.exports = __webpack_public_path__ + "static/media/ic-tab-people.66b60dd6.png";